import styled from 'styled-components'

import MuiFormControl from '@material-ui/core/FormControl'

const FormControl = styled(MuiFormControl)`
  margin-bottom: 16px;
  display: block;
`

export default FormControl
